import { Link } from "react-router-dom";
import { Star, Check, ExternalLink, ArrowRight } from "lucide-react";
import { StarRow } from "../Pill";
import { useContent, mediaUrl } from "../../context/ContentContext";

export default function EditorsChoice() {
  const { c } = useContent();
  const e = c.editorsChoice;
  return (
    <section className="bg-[#f7f8fa] py-20 lg:py-24">
      <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
        <p className="eyebrow">{e.eyebrow}</p>
        <h2 className="font-display mt-3 text-[32px] font-extrabold tracking-tight text-[var(--ink)] sm:text-[40px]">{e.title}</h2>
        <p className="mt-4 max-w-3xl text-[16px] leading-relaxed text-slate-500">{e.description}</p>

        <div className="mt-10 grid grid-cols-1 overflow-hidden rounded-2xl border border-slate-200 bg-white lg:grid-cols-2">
          <div className="relative min-h-[300px]">
            <img src={mediaUrl(e.image)} alt={e.providerName} className="absolute inset-0 h-full w-full object-cover" />
            <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-amber-400 px-3 py-1.5 text-[12px] font-bold text-[var(--navy)]">
              <Star size={13} className="fill-[var(--navy)]" /> {e.badge}
            </span>
          </div>

          <div className="p-8 lg:p-10">
            <div className="flex flex-wrap items-center gap-3">
              <span className="flex items-center gap-1.5">
                <StarRow n={5} size={16} />
                <span className="ml-1 text-[14px] font-bold text-[var(--ink)]">{e.rating}</span>
                <span className="text-[14px] text-slate-400">· {e.reviews}</span>
              </span>
              <a href="#" onClick={(ev) => ev.preventDefault()} className="inline-flex items-center gap-1 text-[13px] font-semibold text-emerald-600 hover:text-emerald-700">
                {e.greenLabel} <ExternalLink size={13} />
              </a>
            </div>
            <h3 className="font-display mt-4 text-[26px] font-extrabold text-[var(--ink)]">{e.providerName}</h3>
            <p className="mt-1 text-[14px] font-semibold text-[var(--brand-blue)]">{e.methodLine}</p>
            <p className="mt-4 text-[15px] leading-relaxed text-slate-500">{e.body}</p>
            <p className="mt-6 text-[13px] font-bold uppercase tracking-wider text-slate-400">{e.reasonsTitle}</p>
            <ul className="mt-3 space-y-2.5">
              {e.reasons.map((r, i) => (
                <li key={i} className="flex items-start gap-2.5 text-[14px] text-[var(--ink)]">
                  <Check size={16} className="mt-0.5 shrink-0 text-emerald-500" strokeWidth={3} />
                  {r}
                </li>
              ))}
            </ul>
            <div className="mt-7 flex flex-wrap gap-3">
              <Link to="/providers/master-odor-removal" className="group inline-flex items-center gap-2 rounded-xl bg-[var(--brand-blue)] px-5 py-3 text-[14px] font-semibold text-white transition-colors hover:bg-[var(--brand-blue-hover)]">
                {e.primaryCta}
                <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <Link to="/compare" className="inline-flex items-center gap-2 rounded-xl border border-slate-200 px-5 py-3 text-[14px] font-semibold text-[var(--ink)] transition-colors hover:bg-slate-50">
                {e.secondaryCta}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
